module.exports = __webpack_public_path__ + "img/LUB00408.196ba262.png";